import { DashboardInfoStatisticForAdminResponse, NotificationItem, PlanPeriodDto } from 'core'
import { NotificationType } from 'core/application/adminDashboard/notifications/getNotifications'
import { W2ReportNotificationYear } from 'core/application/commons/config'

import { useLoginUserV2 } from 'common/hooks'
import { ROUTE_PATHS } from 'common/routePaths'

import ReportNotification from './ReportNotification'
import TotalReimbursementAmount from './TotalReimbursementAmount'
import TotalReimbursementRequest from './TotalReimbursementRequest'

type NotificationsProps = {
  planPeriods: PlanPeriodDto[]
  statisticInfo: DashboardInfoStatisticForAdminResponse
  planPeriodId: string
  notifications: NotificationItem[]
}

const Notifications = ({ planPeriods, statisticInfo, planPeriodId, notifications }: NotificationsProps) => {
  const { user } = useLoginUserV2()

  const productId = user?.productId

  const planPeriod = planPeriods?.find((x) => x.id == planPeriodId)
  const oldPlanPeriod = planPeriods
    ? planPeriods?.find((x) => x.id == statisticInfo?.previousPlanPeriodDetails?.previousPlanPeriodId)
    : null

  return (
    <div>
      {notifications &&
      notifications.length > 0 &&
      notifications.some((x) => x.notificationType !== NotificationType.PopUpForPremiumPlus) ? (
        <>
          {notifications.some((x) => x.notificationType === NotificationType.W2Report) && (
            <ReportNotification
              text={`Your ${W2ReportNotificationYear} W-2 Report is ready to download`}
              route={`${ROUTE_PATHS.REPORTS}`}
              notificationId={
                notifications.find((x) => x.notificationType === NotificationType.W2Report).notificationId
              }
            />
          )}

          {notifications.some((x) => x.notificationType === NotificationType.C1095Report) && (
            <ReportNotification
              text={`Your annual Form 1095 system report is available for download.`}
              route={`${ROUTE_PATHS.REPORTS}/1095-c-reports`}
              notificationId={
                notifications.find((x) => x.notificationType === NotificationType.C1095Report).notificationId
              }
            />
          )}

          {notifications.some((x) => x.notificationType === NotificationType.ReimbursementsDueForCurrentYear) && (
            <TotalReimbursementAmount
              totalReimbursementAmount={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsDueForCurrentYear)
                  .reimbursementAmount
              }
              totalReimbursementDue={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsDueForCurrentYear)
                  .userCount
              }
              productId={productId}
              planPeriod={planPeriod}
            />
          )}

          {notifications.some((x) => x.notificationType === NotificationType.ReimbursementsDueForPreviousYear) && (
            <TotalReimbursementAmount
              totalReimbursementAmount={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsDueForPreviousYear)
                  .reimbursementAmount
              }
              totalReimbursementDue={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsDueForPreviousYear)
                  .userCount
              }
              productId={productId}
              planPeriod={oldPlanPeriod}
            />
          )}

          {notifications.some((x) => x.notificationType === NotificationType.ReimbursementsRequestForCurrentYear) && (
            <TotalReimbursementRequest
              totalReimbursementRequests={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsRequestForCurrentYear)
                  .reimbursementsRequestCount
              }
              planPeriodId={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsRequestForCurrentYear)
                  .planPeriodId
              }
              startDate={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsRequestForCurrentYear)
                  .planPeriodStartDate
              }
            />
          )}

          {notifications.some((x) => x.notificationType === NotificationType.ReimbursementsRequestForPreviousYear) && (
            <TotalReimbursementRequest
              totalReimbursementRequests={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsRequestForPreviousYear)
                  .reimbursementsRequestCount
              }
              planPeriodId={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsRequestForPreviousYear)
                  .planPeriodId
              }
              startDate={
                notifications.find((x) => x.notificationType === NotificationType.ReimbursementsRequestForPreviousYear)
                  .planPeriodStartDate
              }
            />
          )}
        </>
      ) : (
        <p className={'t-no-reimbursement-amount'}>Good work. You’re all caught up. 👍</p>
      )}
    </div>
  )
}

export default Notifications
